import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTimesheetApproverRequest } from '../../../../actions/timesheet';
import NotificationList from './NotificationList';

export function NotificationCard() {
  const dispatch = useDispatch();
  const getListOfApprovals = useSelector((state) => state?.timesheet?.notifications);

  useEffect(() => {
    dispatch(getTimesheetApproverRequest('contractor'));
  }, []);

  return <NotificationList items={getListOfApprovals} />;
}
